import * as React from 'react';
import { clsx as cn } from 'clsx';
import { ACCORDION_SIZE_PARAMS } from '../../constants';
import styles from './styles.module.css';

/**
 * Отдельный айтем внутри Accordion
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AccordionItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    title,
    content,
    icon,
    open,
    handleClick,
    size,
    index
  } = _ref;
  const {
    Title,
    ArrowIcon
  } = ACCORDION_SIZE_PARAMS[size];
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles['container'],
    children: [/*#__PURE__*/_jsxs("button", {
      "data-testid": "accordion-item-".concat(index),
      className: cn(styles['header-container'], styles["size-".concat(size)]),
      type: "button",
      "aria-expanded": open,
      onClick: handleClick,
      children: [icon && /*#__PURE__*/_jsx("div", {
        className: cn(styles['icon'], styles["size-".concat(size)]),
        "aria-hidden": true,
        children: icon
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['title-and-arrow'],
        children: [/*#__PURE__*/_jsx(Title, {
          fontWeight: "bold",
          children: title
        }), /*#__PURE__*/_jsx("div", {
          className: cn(styles['arrow'], styles["size-".concat(size)], {
            [styles['active']]: open
          }),
          "aria-hidden": true,
          children: /*#__PURE__*/_jsx(ArrowIcon, {})
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      role: "region",
      className: cn(styles['content'], styles["size-".concat(size)], {
        [styles['active']]: open
      }),
      children: content
    })]
  });
});
AccordionItem.displayName = 'AccordionItem';